import { Grid } from "@mui/system";
import { LiveCodeBlock } from "../../LiveCodeBlock";
import { RecapCard } from "../../RecapCard";
import VerticalLinearStepper from "../VerticalLinearStepper";
import { Alert, Divider, Typography } from "@mui/material";

export const KdappontCssLesson4 = () => {
  const subjectBlocks = [
    {
      label: "CSS Lists",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <LiveCodeBlock
              live={false}
              code={`ul {/* 1. Browser defaults */}

/* 2. Andere bolletjes */
ul.circle {
  list-style: circle;
}

/* 3. Geen bolletjes (voor menu's) */
ul.none {
  list-style: none;
  padding: 0;
  margin: 0;
}`}
              language="css"
            />
            <br />
            <LiveCodeBlock
              live={false}
              code={`<ul>
  <li>iOS</li>
  <li>Android</li>
</ul>

<ul class="circle">
  <li>iOS</li>
  <li>Android</li>
</ul>

<ul class="none">
  <li>Home</li>
  <li>About</li>
</ul>`}
            />
          </Grid>
          <Grid size={2}>
            <Typography variant="h6">1. Standaard (Browser default)</Typography>
            <ul>
              <li>iOS</li>
              <li>Android</li>
            </ul>

            <Divider sx={{ my: 1 }} />

            <Typography variant="h6">2. Circle style</Typography>
            <ul style={{ listStyleType: "circle", marginBottom: "1rem" }}>
              <li>iOS</li>
              <li>Android</li>
            </ul>

            <Divider sx={{ my: 1 }} />

            <Typography variant="h6">3. List-style: none</Typography>

            <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
              <li>iOS</li>
              <li>Android</li>
            </ul>
          </Grid>
        </Grid>
      ),
    },
    {
      label: "CSS Tables",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <LiveCodeBlock
              live={false}
              code={`table {
  width: 100%;
  text-align: center;
}

th, td {
  border: 1px solid black;
  padding: 8px;
}

th {
  background-color: #f2f2f2;
}`}
              language="css"
            />
            <br />
            <LiveCodeBlock
              live={false}
              code={`<table>
  <tr>
    <th>OS</th>
    <th>Maker</th>
  </tr>
  <tr>
    <td>iOS</td>
    <td>Apple</td>
  </tr>
  <tr>
    <td>Android</td>
    <td>Google</td>
  </tr>
</table>`}
            />
          </Grid>
          <Grid size={2}>
            <style>
              {`
                .demo-table { width: 100%; text-align: center; }
                .demo-table th, .demo-table td { border: 1px solid #ccc; padding: 8px; }
                .demo-table th { background-color: #f2f2f2; font-weight: bold; }
              `}
            </style>

            <table className="demo-table">
              <thead>
                <tr>
                  <th>OS</th>
                  <th>Maker</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>iOS</td>
                  <td>Apple</td>
                </tr>
                <tr>
                  <td>Android</td>
                  <td>Google</td>
                </tr>
              </tbody>
            </table>
          </Grid>
        </Grid>
      ),
    },
    {
      label: "CSS Display",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <Alert severity="info" sx={{ mb: 2 }}>
              <Typography variant="h5">
                <b>Block:</b> Pakt de hele breedte, begint op nieuwe regel
                <br />
                <b>Inline:</b> Pakt alleen de ruimte die nodig is, staat naast
                elkaar
              </Typography>
            </Alert>
            <LiveCodeBlock
              live={false}
              code={`span.block {
  display: block; /* Volledige breedte */
  background: yellow;
}

li.inline {
  display: inline; /* Naast elkaar! */
  background: lightblue;
}

div.none {
  display: none;
}`}
              language="css"
            />
            <br />
            <LiveCodeBlock
              live={false}
              code={`<span class="block">Ik ben nu een block</span>

<ul>
  <li class="inline">Menu 1</li>
  <li class="inline">Menu 2</li>
</ul>`}
            />
          </Grid>
          <Grid size={2}>
            <Typography variant="h6">
              display: block (op een inline element)
            </Typography>
            <span
              style={{
                display: "block",
                background: "yellow",
              }}
            >
              Ik ben nu een block
            </span>

            <Divider sx={{ my: 2 }} />

            <Typography variant="h6">
              display: inline (op list items)
            </Typography>
            <div>
              <ul>
                <li
                  style={{
                    display: "inline",
                    marginRight: "10px",
                    background: "lightblue",
                  }}
                >
                  Menu 1
                </li>
                <li
                  style={{
                    display: "inline",
                    marginRight: "10px",
                    background: "lightblue",
                  }}
                >
                  Menu 2
                </li>
              </ul>
            </div>
          </Grid>
        </Grid>
      ),
    },
    {
      label: "CSS Max-width",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <LiveCodeBlock
              live={false}
              code={`div.box {
  background: pink;
  height: 50px;
  border: 1px solid red;
  text-align: center;
}

.fixed-width {
  width: 1000px; /* Blijft altijd 1000px */
}

.max-width {
  max-width: 1000px; /* Wordt max 1000px, maar kleiner als het scherm kleiner is */
  background: lightgreen;
  border: 1px solid green;
}`}
              language="css"
            />
          </Grid>
          <Grid size={2}>
            <Typography variant="h6">
              width: 1000px (Loopt uit beeld)
            </Typography>
            <div
              style={{
                width: "1000px",
                height: "50px",
                background: "pink",
                border: "1px solid red",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Vaste breedte
            </div>

            <Typography variant="h6">max-width: 1000px (Responsive)</Typography>
            <div
              style={{
                maxWidth: "1000px",
                width: "100%",
                height: "50px",
                background: "lightgreen",
                border: "1px solid green",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Flexibele breedte
            </div>
          </Grid>
        </Grid>
      ),
    },
    {
      label: "CSS Position (Relative & Absolute)",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <Alert severity="info" sx={{ mb: 2 }}>
              <Typography variant="h5">
                <i>Relative</i> = <b>Prikbord</b> <br /> <i>Absolute</i> ={" "}
                <b>Briefje</b>
                <br />
                <br />
                Je prikt het briefje vast op het prikbord
                <br />
                Als het prikbord géén <code>position: relative</code> heeft,
                zoekt het briefje de volgende ouder (uiteindelijk de
                browser/muur)
              </Typography>
            </Alert>
            <LiveCodeBlock
              live={false}
              code={`/* De ouder (Het Prikbord) */
.notice-board {
  position: relative;
  width: 300px;
  height: 200px;
  border: 2px solid black;
}

/* Het kind (Het Briefje) */
.post {
  position: absolute;
  top: 20px;
  right: 50px;
  background: yellow;
  padding: 5px;
}`}
              language="css"
            />
            <br />

            <LiveCodeBlock
              live={false}
              code={`<div class="notice-board">
  <div class="post">Briefje</div>
</div>`}
            />
          </Grid>
          <Grid size={2} sx={{ pt: 4 }}>
            <div
              style={{
                position: "relative",
                width: "300px",
                height: "200px",
                border: "2px solid black",
                background: "white",
                margin: "20px auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              ></div>

              <div
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "50px",
                  background: "yellow",
                  padding: "5px 10px",
                }}
              >
                Briefje (abs)
              </div>
            </div>
          </Grid>
        </Grid>
      ),
    },
    {
      label: "CSS Z-Index",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <LiveCodeBlock
              live={false}
              code={`/* Z-index: Bepaalt de "laag" (diepte) */
/* Werkt alleen als position != static */

.box-blue {
  position: relative;
  z-index: 1;
  padding: 50px;
}

.box-red {
  position: relative;
  z-index: 2; 
  top: -30px; 
  padding: 50px;
}`}
              language="css"
            />
            <br />

            <LiveCodeBlock
              live={false}
              code={`<div class="box-blue">z-index: 1</div>
<div class="box-red">z-index: 2</div>`}
            />
          </Grid>
          <Grid size={2}>
            <div
              style={{
                background: "blue",
                color: "white",
                width: "300px",
                // height: "60px",
                position: "relative",
                zIndex: 1,
                padding: "50px",
              }}
            >
              z-index: 1
            </div>
            <div
              style={{
                background: "red",
                color: "white",
                width: "300px",
                // height: "60px",
                position: "relative",
                zIndex: 2,
                top: "-30px",
                marginLeft: "30px",
                padding: "50px",
              }}
            >
              z-index: 2
            </div>
          </Grid>
        </Grid>
      ),
    },
  ];

  return (
    <VerticalLinearStepper
      steps={[
        {
          label: "👨🏼‍🏫 Voor vandaag",
          description: `Lists | Tables | Display | Max-width | Position | Z-Index`,
          content: (
            <Grid container columns={1} spacing={2}>
              {subjectBlocks.map((subject, index) => (
                <Grid key={index} size={1} sx={{ "& > *": { height: "100%" } }}>
                  <RecapCard subject={subject} />
                </Grid>
              ))}
            </Grid>
          ),
        },
      ]}
    />
  );
};
